var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVersionsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16H7C6.46957 16 5.96086 15.7893 5.58579 15.4142C5.21071 15.0391 5 14.5304 5 14V6C5 5.46957 5.21071 4.96086 5.58579 4.58579C5.96086 4.21071 6.46957 4 7 4H15C15.5304 4 16.0391 4.21071 16.4142 4.58579C16.7893 4.96086 17 5.46957 17 6V9",
    stroke: "#0066CC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 4,
    stroke: "#0066CC",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.5V18",
    stroke: "#0066CC",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7549 16.2441L14.2549 16.2441",
    stroke: "#0066CC",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersionsIcon);
export default __webpack_public_path__ + "static/media/Versions_Icon.adb498ae71ac2a1071ec623eb7a8b847.svg";
export { ForwardRef as ReactComponent };